
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app-store/[...appStoreAppDetails]",
      function () {
        return require("private-next-pages/app-store/[...appStoreAppDetails].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app-store/[...appStoreAppDetails]"])
      });
    }
  